import {
  CMAApi,
  CMAPropertiesApi,
  Configuration,
  RequestContext,
} from "./generated";

async function preMiddleware(context: RequestContext) {
  context.init.credentials = "include";
  return context;
}

function getConfig() {
  return new Configuration({
    basePath: `${process.env.SIDEKICK_COMPS_API_URL}`,
  });
}

export const getCMAApiClient: () => CMAApi = () => {
  return new CMAApi(getConfig()).withPreMiddleware(preMiddleware);
};

export const getCMAPropertiesApiClient: () => CMAPropertiesApi = () => {
  return new CMAPropertiesApi(getConfig()).withPreMiddleware(preMiddleware);
};
